import React from "react";

import BenefitCard from "./components/BenefitCard/BenefitCard";

import warningSystemIcon from '../../../utils/assets/home/icons/warning-system-icon.png';
import insuranceIcon from '../../../utils/assets/home/icons/insurance-icon.png';
import searchReputationIcon from '../../../utils/assets/home/icons/search-reputation-icon.png';
import blackMarket from '../../../utils/assets/home/icons/black-market.png' ;
import identifyRecoveryIcon from '../../../utils/assets/home/icons/identity-recovery-icon.png';
import emailSecutiryIcon from '../../../utils/assets/home/icons/email-security-icon.png';
import legalSupportIcon from '../../../utils/assets/home/icons/legal-support-icon.png';
import criminalRecordIcon from '../../../utils/assets/home/icons/criminal-record-icon.png';
import walletIcon from '../../../utils/assets/home/icons/wallet-icon.png';
import creditFreezesIcon from '../../../utils/assets/home/icons/credit-freezes.png';
import fraudAlertIcon from '../../../utils/assets/home/icons/fraud-alert-icon.png';

import './Benefit.css';
const Benefit = ({props}) => {
    
  const benefitCardInformation = [
    {
        cardTitle : "ID Early Warning System",
        cardIcon : warningSystemIcon,
        cardAbout : "If your identity is being used by someone else on the web, you can quickly detect and be alerted.",
        cardDescription : "Our innovative identity theft system scans hundreds of pieces of data at various random intervals, looking for signs of identity theft."
    },
    {
        cardTitle : "Internet Monitoring Service",
        cardIcon : warningSystemIcon,
        cardAbout : "Track and alert when your personal information is detected on unsafe or suspicious websites.",
        cardDescription : "Our system searches the web to detect signs that your identity or sensitive data has been exposed online."
    },
    {
        cardTitle : "Lost Wallet Service",
        cardIcon : walletIcon,
        cardAbout : "Eliminate the stress of reporting your cards if your wallet or purse is stolen.",
        cardDescription : "Our service makes it harder for criminals to steal your money by keeping your critical financial information safe in one place, giving you time to contact financial institutions quickly."
    },
    {
        cardTitle : "Identity Theft Insurance",
        cardIcon : insuranceIcon,
        cardAbout : "Your coverage can help you recover between $25K and $1M for fraud-related expenses.",
        cardDescription : "Identity Theft Reimbursement Insurance covers notary fees, certified mail fees, lost wages, loan application fees, attorney fees and more."
    },
    {
        cardTitle : "Fraud Alert Assistance",
        cardIcon : fraudAlertIcon,
        cardAbout : "Anyone concerned about identity theft needs to focus on protecting their credit profile.",
        cardDescription : "Learn how to set credit fraud alerts on your accounts with step-by-step instructions from our experts. Fraud alerts can be one of your best identity protection tools."
    },
    {
        cardTitle : "Credit Security Freezes",
        cardIcon : creditFreezesIcon,
        cardAbout : "Block creditors from accessing your credit information without your permission by locking your accounts.",
        cardDescription : "If you believe your personal information has been stolen, placing a credit freeze can help protect your profile from fraud."
    },
    {
        cardTitle : "Online Reputation Search",
        cardIcon : searchReputationIcon,
        cardAbout : "In the digital world, you want to protect your good name and the people you love.",
        cardDescription : "Our program scans the Internet for derogatory information about you or your family and presents it for review."
    },
    {
        cardTitle : "Internet Black Market Monitoring",
        cardIcon : blackMarket,
        cardAbout : "Your data could be compromised by opening malicious emails or visiting unsafe websites.",
        cardDescription : "We constantly monitor the Deep Web for leaks of your personal data exposed by potential hacks or breaches."
    },
    {
        cardTitle : "Identity Recovery",
        cardIcon : identifyRecoveryIcon,
        cardAbout : "We are here to help you recover your identity, saving you time, money, and stress.",
        cardDescription : "Our experts can guide you through the entire recovery process, or manage it on your behalf with full support."
    },
    {
        cardTitle : "Junk Mail Reduction Service",
        cardIcon : emailSecutiryIcon,
        cardAbout : "Tired of having your mailbox filled with junk mail and unsolicited advertisements?",
        cardDescription : "By removing your name from marketing lists and databases, our Green Mailbox service helps protect your personal information from being abused."
    },
    {
        cardTitle : "Legal Support",
        cardIcon : legalSupportIcon,
        cardAbout : "Have questions about your legal rights when your identity is stolen or misused?",
        cardDescription : "Our privacy and security team is available to assist you in understanding and navigating legal protections and identity theft laws."
    },
    {
        cardTitle : "Criminal Identity Theft Monitoring",
        cardIcon : criminalRecordIcon,
        cardAbout : "Worried someone might be committing crimes using your name?",
        cardDescription : "We monitor criminal databases and records for signs that your identity may have been falsely used in law enforcement files."
    }
];



    return (
     <section className="Benefit__main-contiainer">
        <div className="Benefit__inner-contianer">
            {
                benefitCardInformation.map((cardInfo, index)=>(
                    <BenefitCard key={index} props={cardInfo}/>
                ))
            }
        </div>
     </section>
    );
};

export default Benefit; 